module.exports = __webpack_public_path__ + "img/stackslash-process-1-mobile.814a99ad.jpg";